import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { CustomBadge } from '@/components/zthd/badge'
import { campaignStatusMap, getStatusConfig } from '@/comm/campaign-status'
import useSWR from 'swr'
import useSWRMutation from 'swr/mutation'
import { mutateRequest, putFetcher } from '@/hooks'
import Loader from '@/components/zthd/Loader'

const CampaignStatusButton = ({ campaignId }) => {
  const { data: campaign, mutate } = useSWR([`/campaigns/${campaignId}`])
  
  const { trigger, isMutating } = useSWRMutation(
    `/campaigns/${campaignId}`,
    putFetcher,
  )

  const handleStatusChange = async (newState) => {
    await trigger({ state: newState })
    // Update local data
    mutate()
    // Refresh campaigns list
    mutateRequest(`/campaigns`)
  }

  if (!campaign) {
    return <Loader>Loading status...</Loader>
  }

  const status = getStatusConfig(campaign.state)

  if (isMutating) {
    return <Loader>Updating...</Loader>
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild disabled={isMutating}>
        <Button variant="outline" size="sm">
          <CustomBadge variant={status.variant} size="sm">
            {status.label}
          </CustomBadge>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>Set Status</DropdownMenuLabel>
        {Object.entries(campaignStatusMap).map(([key, { label, variant }]) => (
          <DropdownMenuItem
            key={key}
            onClick={() => handleStatusChange(Number(key))}
            disabled={isMutating}
          >
            <CustomBadge variant={variant} size="sm">
              {label}
            </CustomBadge>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default CampaignStatusButton 